(function (scope) {
  'use strict';
  const measure = value => {
    const text = String(value ?? '').trim().replace(/[″\"]/g, '').replace(/\s*(?:inches|inch|in\.)\s*$/i, '').trim();
    const fraction = text.match(/^(?:(\d+)\s+)?(\d+)\s*\/\s*(\d+)$/);
    if (fraction && Number(fraction[3])) return Number(fraction[1] || 0) + Number(fraction[2]) / Number(fraction[3]);
    return /^(?:\d+(?:\.\d+)?|\.\d+)$/.test(text) ? Number(text) : NaN;
  };
  function pair(value) {
    const parts = String(value ?? '').split(/\s*[x×]\s*/i);
    return parts.length === 2 ? parts.map(measure) : [NaN, NaN];
  }
  function prepare(product, index, basis) {
    const p = { ...product, index };
    const overall = pair(p.overall), common = pair(p.common);
    const numeric = [measure(p.width), measure(p.height)];
    const valid = values => values.every(v => Number.isFinite(v) && v > 0);
    const actual = valid(overall) ? overall : numeric;
    const chosen = p.door && basis === 'common' && valid(common) ? common : actual;
    [p.w, p.h] = chosen;
    p.measured = valid(chosen);
    const tags = Array.isArray(p.tags) ? p.tags.map(String) : [];
    const title = String(p.title || '').replace(/®/g, '').trim();
    const size = title.match(/\d+(?:\.\d+)?\s*[x×]\s*\d+(?:\.\d+)?/i);
    const before = size ? title.slice(0, size.index).trim() : title;
    const vendor = String(p.vendor || '').replace(/®/g, '').trim();
    const vendorLower = vendor.toLowerCase();
    const seriesTag = tags.filter(tag => tag.toLowerCase().startsWith(vendorLower) && vendorLower && before.toLowerCase().includes(tag.toLowerCase()))
      .sort((a, b) => b.length - a.length)[0];
    const vendorAt = before.toLowerCase().indexOf(vendorLower);
    const knownSeries = vendorAt >= 0 ? before.slice(vendorAt + vendor.length).match(/^\s+(250 Series|350 Series|150 Series|450 Series|Lifestyle|Impervia|Reserve|Architect(?: Series)?|ProLine|Designer|Pinnacle|Next Dimension|Acclaim(?: Series)?|Elevate|Essential|Signature(?: Series)?)/i) : null;
    p.series = seriesTag || (vendor + (knownSeries ? knownSeries[0] : '')) || before;
    const detail = before.replace(p.series, '').replace(/^[\s–—:-]+|[\s–—:-]+$/g, '').trim();
    p.cardType = detail || String(p.detail || p.type || '');
    p.orientation = String(p.orientation || tags.find(tag => /^Door Orientation_/i.test(tag))?.replace(/^Door Orientation_/i, '') || '');
    p.stud = String(p.stud || tags.find(tag => /^Stud Size_/i.test(tag))?.replace(/^Stud Size_/i, '') || '');
    p.material = String(p.material || ''); p.color = String(p.color || ''); p.interior = String(p.interior || ''); p.grids = String(p.grids || ''); p.gridDetail = String(p.gridDetail || '');
    return p;
  }
  function matches(p, state, omit) {
    for (const axis of ['width', 'height']) {
      const value = axis === 'width' ? p.w : p.h;
      const low = state[axis + 'Min'], high = state[axis + 'Max'];
      if ((low !== null || high !== null) && (!Number.isFinite(value) || (low !== null && value < low - 1e-8) || (high !== null && value > high + 1e-8))) return false;
    }
    if (state.priceMin !== null && p.price < state.priceMin * 100 - 1e-8) return false;
    if (state.priceMax !== null && p.price > state.priceMax * 100 + 1e-8) return false;
    if (state.inStock && !p.available) return false;
    for (const [key, values] of Object.entries(state.facets || {})) {
      if (key !== omit && values.length && !values.includes(String(p[key] ?? ''))) return false;
    }
    return true;
  }
  function relevance(product, query) {
    const text = String(query || '').trim().toLocaleLowerCase();
    if (!text) return 0;
    const title = String(product.title || '').toLocaleLowerCase();
    if (String(product.sku || '').toLocaleLowerCase() === text) return 1000;
    if (title === text) return 100;
    if (title.startsWith(text)) return 80;
    if (title.includes(text)) return 60;
    const words = text.split(/\s+/).filter(Boolean);
    const titleHits = words.filter(word => title.includes(word)).length;
    const metadata = [product.vendor, product.type, product.detail, ...(product.tags || [])].join(' ').toLocaleLowerCase();
    const metadataHits = words.filter(word => metadata.includes(word)).length;
    return 40 * titleHits / words.length + 10 * metadataHits / words.length;
  }
  function sorted(products, sort, query) {
    return [...products].sort((a, b) => {
      if (sort === 'relevance') return relevance(b, query) - relevance(a, query) || a.index - b.index;
      if (sort === 'price-ascending') return a.price - b.price || a.index - b.index;
      if (sort === 'price-descending') return b.price - a.price || a.index - b.index;
      if (sort === 'title-ascending') return a.title.localeCompare(b.title, undefined, { numeric: true });
      if (sort === 'title-descending') return b.title.localeCompare(a.title, undefined, { numeric: true });
      if (sort === 'created-ascending') return Number(a.created) - Number(b.created) || a.index - b.index;
      if (sort === 'created-descending') return Number(b.created) - Number(a.created) || a.index - b.index;
      return a.index - b.index;
    });
  }
  const api = { measure, pair, prepare, matches, sorted, relevance };
  if (typeof module === 'object' && module.exports) module.exports = api;
  else scope.ClarkCatalogCore = api;
})(typeof window === 'undefined' ? {} : window);
